import { observer } from 'mobx-react-lite';
import { Document, Page } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { styles } from './style';
import { useStore } from '../../../../app/stores/store';
import { useEffect, useState } from 'react';
import { metadataType } from '../../../../app/api/types';
import { FilmType, SourceDeliverable, UCC_ID, label } from './type';
import DynamicTableBody from './DynamicTableBody';

interface LocalMetaData {
  [key: number]: metadataType[];
}
interface DynamicTableData {
  headers: string[];
  body: any[];
}

function AudioSyncReport() {
  const {
    viewStore: { metadata, parentMetadata },
    activityStore: { selectedActivity },
  } = useStore();
  const [localMetaData, setLocalMetaData] = useState<LocalMetaData>({});
  const [dynData, setDynData] = useState<DynamicTableData>({
    headers: [],
    body: [],
  });
  useEffect(() => {
    if (selectedActivity?.id) {
      parentMetadata({ itemId: selectedActivity?.id });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const tempTableData: LocalMetaData = {
      0: [],
      1: [],
      2: [],
      3: [],
    };
    metadata?.forEach((m: metadataType) => {
      if (UCC_ID.includes(m.elementName)) {
        tempTableData[0].push(m);
      }
      if (FilmType.includes(m.elementName)) {
        tempTableData[1].push(m);
      }
      if (SourceDeliverable.includes(m.elementName)) {
        tempTableData[2].push(m);
      }
      if (['AVSync Overall Remark'].includes(m.elementName)) {
        tempTableData[3].push(m);
      }
      if (
        m.elementType === 'DynamicTable' &&
        m.elementName === 'NFAI AVSyn Remarks'
      ) {
        getDynamicTableData(m.elementValue);
      }
    });
    function sortArrayByOrder(inputArray: any[], sortingOrder: string[]) {
      const elementIndexMap: Record<string, number> = {};
      sortingOrder.forEach((element, index) => {
        elementIndexMap[element] = index;
      });

      return inputArray.slice().sort((a, b) => {
        const aIndex = elementIndexMap[a.elementName];
        const bIndex = elementIndexMap[b.elementName];
        return aIndex - bIndex;
      });
    }
    tempTableData[0] = sortArrayByOrder(tempTableData[0], UCC_ID);
    tempTableData[1] = sortArrayByOrder(tempTableData[1], FilmType);
    tempTableData[2] = sortArrayByOrder(tempTableData[2], SourceDeliverable);
    setLocalMetaData(tempTableData);
  }, [metadata]);

  const getDynamicTableData = (eleVal: string) => {
    const temp: DynamicTableData = {
      headers: [],
      body: [],
    };

    let columnHeaders: string[] = [];
    let tempValue: any[] = [];

    if (eleVal?.includes('DynamicTable|')) {
      let stringData = eleVal?.split('DynamicTable|')?.[1];
      stringData = stringData?.split('_')?.join(' ')?.replaceAll(/\n/g,'');
      tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
      if(tempValue.length === 0) return;
      columnHeaders = Object.keys(tempValue?.[0] || []);
      columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
    }
    temp.headers = columnHeaders;
    temp.body = tempValue;
    setDynData(temp);
  };

  const getColumn = (data: metadataType[], num: number) => {
    const halfLength = Math.ceil(data?.length / 2);
    return num === 1 ? data?.slice(0, halfLength) : data?.slice(halfLength);
  };

  const elementOne = (
    <html>
      <body>
        <style>{styles}</style>
        <div id="container">
          <br />
          <br />
          <br />
          <table className="AASQR-table">
            <tr aria-rowspan={3} className="center-content">
              <td className="baby-blue-color">AUDIO SYNC QC REPORT</td>
            </tr>

            {localMetaData[0]?.map((l: any, index: number) => (
              <tr key={index}>
                <td style={{ width: '10px' }} className="baby-blue-color">
                  {label[l.elementName as keyof typeof label] || l.elementName}
                </td>
                <td className="center-content lightYellow-color red-color">
                  {label[l.elementValue as keyof typeof label] ||
                    l.elementValue}
                </td>
              </tr>
            ))}

            {/* Second row */}

            {getColumn(localMetaData[1], 1)?.map((l, index) => (
              <tr key={l.elementIndex}>
                <td className=" lightYellow-color">
                  {label[l.elementName as keyof typeof label] || l.elementName}:
                </td>
                <td className="center-content lightYellow-color">
                  {l.elementValue}
                </td>
                <td className=" lightYellow-color"></td>
                <td className=" lightYellow-color"></td>
                <td className=" lightYellow-color">
                  {label[
                    getColumn(localMetaData[1], 2)?.[index]
                      ?.elementName as keyof typeof label
                  ] || getColumn(localMetaData[1], 2)?.[index]?.elementName}
                  {(label[
                    getColumn(localMetaData[1], 2)?.[index]
                      ?.elementName as keyof typeof label
                  ] || getColumn(localMetaData[1], 2)?.[index]?.elementName) !==
                  undefined
                    ? ':'
                    : ''}
                </td>
                <td className="center-content lightYellow-color">
                  {getColumn(localMetaData[1], 2)?.[index]?.elementValue}
                </td>
              </tr>
            ))}
          </table>
          <table className="border-top-0 AASQR-table">
            <tr>
              <td className="source center-content lightRed-color border-top-0">
                Source
              </td>
              <td className="border-top-0"></td>
              <td className="border-top-0"></td>
              <td className="Deliverable border-top-0 lightRed-color">
                Deliverable
              </td>
            </tr>

            {localMetaData[2]?.map((l) => (
              <tr key={l.elementIndex}>
                <td className="lightRed-color">
                  {label[l.elementName as keyof typeof label] || l.elementName}
                </td>
                <td>{['Bit Depth'].includes(l.elementName) ? `${l.elementValue} BIT` :l.elementValue}</td>
                <td className="lightRed-color center-right">
                  {label[l.elementName as keyof typeof label] || l.elementName}
                </td>
                <td>{['Bit Depth'].includes(l.elementName) ? `${l.elementValue} BIT` : l.elementValue}</td>
              </tr>
            ))}
            <tr>
              <td className="OverallRemarks WhiteSmoke-color">
                Overall Remark
              </td>
              <td className="Ananya_Sound_Rescans WhiteSmoke-color">
                {localMetaData[3]?.[0]?.elementValue}
              </td>
            </tr>
          </table>

          <table className="AASQR-table border-top-0">
            <thead className="border-top-0">
              <tr className="border-top-0">
                {dynData.headers?.map((headerName) => (
                  <td
                    className={
                      'center-content padding-2  l-grey-bg bold-extra border-top-0 cyan-blue-color'
                    }
                    key={headerName}
                  >
                    {headerName}
                  </td>
                ))}
              </tr>
            </thead>
            <DynamicTableBody dynData={dynData} />
          </table>
        </div>
      </body>
    </html>
  );

  const htmlOne = ReactDOMServer.renderToStaticMarkup(elementOne);

  return (
    <Document>
      <Page style={{ padding: '18px' }}>
        <Html>{htmlOne}</Html>
      </Page>
    </Document>
  );
}
export default observer(AudioSyncReport);
